'use client';

import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import PgProductGroupItem from './PgProductGroupItem';
import { PgListIntroProps } from './PgProductTypes';

/**
 * PG专题页商品组列表组件
 * 对应Vue组件: ListIntro.vue
 */
const PgListIntro: React.FC<PgListIntroProps> = ({ productList }) => {
  // 视频加载状态
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false);

  // 组件检测 - 当组件进入视口时开始加载视频
  const [componentRef, componentInView] = useInView({
    threshold: 0.0001, // 0.01%露出就触发
    triggerOnce: true, // 只触发一次
  });

  // 当组件进入视口时，开始加载视频
  useEffect(() => {
    if (componentInView) {
      setShouldLoadVideo(true);
    }
  }, [componentInView]);

  if (!productList || productList.length === 0) {
    return null;
  }

  return (
    <div ref={componentRef} className="list-intro">
      <div className="intro-list">
        {productList.map((group, groupIndex) => {
          // 生成稳定的key，基于产品ID而不是index
          const productIds = group.map((product) => product.id || product.shop_sku).filter(Boolean);
          const stableKey =
            productIds.length > 0
              ? `group-${productIds.join('-')}`
              : `group-fallback-${groupIndex}`;

          return (
            <PgProductGroupItem
              key={stableKey}
              productGroup={group}
              groupIndex={groupIndex}
              shouldLoadVideo={shouldLoadVideo}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PgListIntro;
